import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import plantsImage from "images/keyservice/locksmithogimage.jpg";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg";
import ThreeColSimple from "./ThreeColSimple";
import Coverage from "./TwoColSingleFeatureWithStats";

const Container = tw.div`relative bg-white`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto relative`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded-full bg-cover bg-center h-full shadow-lg`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left text-[#3F62A3]`;
const Heading = tw(
  SectionHeading
)`mt-4 text-[#002952] text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-black`;

const Statistics = tw.div`flex flex-col items-center sm:block text-center md:text-left mt-6`;
const Statistic = tw.div`text-left sm:inline-block sm:mr-12 last:mr-0 mt-4`;
const Value = tw.div`font-bold text-lg sm:text-xl lg:text-2xl text-[#3F62A3] tracking-wide`;
const Key = tw.div`font-medium text-[#002952]`;

const DecoratorBlob = styled(SvgDotPattern)(props => [
  tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-[#3F62A3] -z-10`,
]);

export default ({
  subheading = "Onze ervaring",
  heading = (
    <>
      Jarenlange <span className="text-[#3F62A3]">ervaring</span> in
      betrouwbare beveiliging.
    </>
  ),
  description = "Bij Safety Locks combineren we vakmanschap met moderne technieken. Ons team bestaat uit gecertificeerde slotenmakers met jarenlange ervaring in het beveiligen van woningen en bedrijfspanden. Of het nu gaat om het openen van deuren, het vervangen van sloten of het plaatsen van driepuntssluitingen; wij leveren kwaliteit, service en betrouwbaarheid in elke regio van Nederland.",
  imageSrc = plantsImage,
  imageCss = null,
  imageContainerCss = null,
  imageDecoratorBlob = false,
  imageDecoratorBlobCss = null,
  imageInsideDiv = true,
  statistics = null,
  textOnLeft = false,
}) => {
  const defaultStatistics = [
    { key: "Tevreden klanten", value: "300+" },
    { key: "Voltooide opdrachten", value: "800+" },
  ];

  if (!statistics) statistics = defaultStatistics;

  return (
    <Container>
      {/* Optional pre-sections */}
      <ThreeColSimple />
      <Coverage />

      <TwoColumn css={!imageInsideDiv && tw`md:items-center`}>
        <ImageColumn css={imageContainerCss}>
          {imageInsideDiv ? (
            <Image imageSrc={plantsImage} css={imageCss} />
          ) : (
            <img src={imageSrc} css={imageCss} alt="Safety Locks service" />
          )}
          {imageDecoratorBlob && <DecoratorBlob css={imageDecoratorBlobCss} />}
        </ImageColumn>

        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            <Description>{description}</Description>

            <Statistics>
              {statistics.map((statistic, index) => (
                <Statistic key={index}>
                  <Value>{statistic.value}</Value>
                  <Key>{statistic.key}</Key>
                </Statistic>
              ))}
            </Statistics>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
